import CreatePassword from './create-password';

export default CreatePassword;
